import DataSource from 'devextreme/data/data_source';

export class BdsSupplierSearchDialogModel {
    title?: string;
    actionText: string;
    dismissiveText = 'Cancel';
    defaultFastracName = 'SEARCH SUPPLIER';
    source?: DataSource;
}
